export default __webpack_public_path__ + "static/media/bonus-test-execution-reward.6f01786e.mp3";